import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { PeriodicExecution } from '../model/periodicExecution';
import { DeviceService } from '../service/device.service';
import { TimeSlotDialogComponent } from '../time-slot-dialog/time-slot-dialog.component';
import { Log } from '../util/log';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { StringHelper } from '../util/stringHelper';
import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Overlay } from '@angular/cdk/overlay';
import * as moment from 'moment';

@Component({
  selector: 'app-add-periodic-executions',
  templateUrl: './add-periodic-executions.component.html',
  styleUrls: ['./add-periodic-executions.component.css']
})
export class AddPeriodicExecutionsComponent implements OnInit {

  @ViewChild('loader', { static: true }) loader;

  description: string = "";

  noDeviceSelectedError: boolean = false;

  periodicExecution: PeriodicExecution;

  devices: DevicePilomat[] = [];
  selectedDevices: string[] = [];

  deviceSelected: boolean = false;

  allDays: boolean[] = [];

  @ViewChild('deviceslisttable', { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = [
    'serial',
    'name',
    'checkbox'
  ];

  constructor(
    private deviceService: DeviceService,
    private overlay: Overlay,
    public dialogRef: MatDialogRef<AddPeriodicExecutionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
  ) {
    this.devices = data.devices;
    this.selectedDevices = [];
    for (let i = 0; i < this.devices.length; i++) {
      this.devices[i].selected = false;
    }

    this.periodicExecution = new PeriodicExecution();
    // this.periodicExecution.timeMask = "111111111111111111111111111111111111111111111111";
    this.periodicExecution.timeMask5min = "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111"
    this.periodicExecution.dayMask = 127;

    for (let i = 0; i < 7; i++) {
      this.allDays.push(this.periodicExecution.isDayAllowed(i + 1));
    }

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.table.dataSource = new MatTableDataSource(this.devices);
    this.table.dataSource.sort = this.sort;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addSelectedDevice(device) {


    if (device.selected) {
      this.deviceSelected = false;
      for (let i = 0; i < this.selectedDevices.length; i++) {
        if (this.selectedDevices[i] == device.serial) {
          this.selectedDevices.splice(i, 1);
        }
      }
      device.selected = false;
    } else {
      this.selectedDevices.push(device.serial);
      this.deviceSelected = true;
      device.selected = true;
    }
  }

  onDayChanged(day: number, event: any) {
    let value: boolean = event.target.checked;
    this.allDays[day - 1] = value;
  }

  addTimeSlot() {
    let minPrecision = 5;
    const dialogRef = this.dialog.open(TimeSlotDialogComponent, {
      width: "450px",
      data: { minPrecision }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.periodicExecution.timeSlots.push(result);
      }
    });
  }

  deleteTimeSlot(index: number) {
    this.periodicExecution.timeSlots.splice(index, 1);
  }

  createExecution() {

    this.noDeviceSelectedError = false;
    if (this.selectedDevices.length == 0) {
      this.noDeviceSelectedError = true;
    } else {
      this.loader.showLoading();

      this.periodicExecution.timeZone = moment.tz.guess();

      // let timeMask: string = "000000000000000000000000000000000000000000000000";
      let timeMask5min: string = "000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";


      if (this.periodicExecution.timeSlots.length > 0) {
        for (let i = 0; i < this.periodicExecution.timeSlots.length; i++) {
          let timeSlotMask = TimeSlotHelper.timeSlot5MinToBinaryString(
            this.periodicExecution.timeSlots[i]
          );

          for (let j = 0; j < 288; j++) {
            if (timeSlotMask.charAt(j) == "1") {
              timeMask5min = StringHelper.replaceAt(timeMask5min, j, "1");
            }
          }
        }
      } else {
        timeMask5min = "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111";
      }

      let dayMask: number = 0;
      for (let i = 0; i < this.allDays.length; i++) {
        if (this.allDays[i]) {
          dayMask |= 1 << i;
        }
      }

      // this.periodicExecution.timeMask = timeMask;
      this.periodicExecution.timeMask5min = timeMask5min; 
      this.periodicExecution.dayMask = dayMask;
      this.periodicExecution.operationType = PeriodicExecution.OperationTypeForcedLow;
      this.periodicExecution.description = this.description;

      this.createUpdatePeriodicExecutions(0);
    }
  }

  createUpdatePeriodicExecutions(index: number) {
    if (index < this.selectedDevices.length) {
      this.periodicExecution.serial = this.selectedDevices[index];
      this.deviceService.updatePeriodicExecution(this.selectedDevices[index], this.periodicExecution).subscribe((response) => {
        this.createUpdatePeriodicExecutions(index + 1);
      }, (err) => {
        Log.debug(err);
        this.dialogRef.close("Error");
      });
    } else {
      setTimeout(() => {
        this.dialogRef.close("Success");
      }, 250);
    }
  }
}
